export default __webpack_public_path__ + "static/media/kwik_color.f6459d28.png";